import React from 'react'

import { renderers } from '@markdoc/markdoc'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import { Heading } from '../SyntaxRenderer/components/Heading'
import { Table } from '../SyntaxRenderer/components/Table'
import { Prose } from '~/components/ProseWrapper'
import { Fence } from '~/components/SyntaxRenderer/components/Fence'
import { MarkdownLink as Link } from '~/components/SyntaxRenderer/components/Link'

export interface HeroSectionProps {
  heroImage?: string;
  illustrationImage?: string;
  pageDescription?: any;
  fontFamily?: string;
}

export const HeroSection = ({
  heroImage,
  illustrationImage,
  pageDescription,
  fontFamily
}: HeroSectionProps) => {
  const { t } = useTranslation()

  if (!heroImage && !illustrationImage && (!pageDescription || pageDescription?.length === 0)) {
    return null
  }

  return (
    <header className="max-w-[80rem] mx-auto my-6 md:my-9 xl:my-12 grid grid-cols-12 lg:gap-x-9 gap-y-6 md:gap-y-9 xl:gap-y-12 px-6 md:px-9 xl:px-[3.75rem]" role="banner">
      {heroImage && <div className="col-span-12 xl:col-span-6">
        <img src={heroImage} className="max-w-100% max-h-[80px]" alt={t('portal.landingPage.hero.heroImageAlt')} />
      </div>}
      {pageDescription &&
        <div
          className={clsx(
            'col-span-12 md:col-span-6',
            heroImage && 'row-start-auto md:row-start-2',
          )}
          role="heading"
        >
          <Prose style={{ fontFamily }}>
            {renderers.react(
              pageDescription,
              React,
              {
                components: {
                  Fence,
                  Table,
                  Link,
                  Heading,
                }
              }
            )}
          </Prose>
        </div>
      }
      {illustrationImage &&
        <div className={clsx(
          'md:col-span-6 flex justify-center',
          heroImage && 'row-start-auto md:row-start-2',
          pageDescription && 'col-span-12',
          !pageDescription && 'col-span-6',
        )}>
          <img src={illustrationImage} className="max-w-100% max-h-[320px] self-center" alt={t('portal.landingPage.hero.illustrationImageAlt')} />
        </div>
      }
    </header >
  )
}